import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AdminDashboard } from './pages/AdminDashboard';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen w-full bg-white text-gray-900 font-sans" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/91311" element={<LandingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/admin" element={<AdminDashboard data-id="element-8" />} data-id="element-7" />
        </Routes>
      </div>
    </BrowserRouter>;
}